import { AsyncTypeahead,Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.bs5.css";
import React,{useRef} from "react";
export default (props) => {
    const ref = useRef();
    const filterBy = () => true;

    const uuidv4 = () => {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
    }

    if (props.autofocus) ref.current?.focus()

    return (
        <>
        {props.easy && (
            <Typeahead
            labelKey="label"
            newSelectionPrefix="Přidat: "
            paginationText="Zobrazit více"
            id={uuidv4}
            {...props}
             />
        )}
        {!props.easy && (
            <AsyncTypeahead
            filterBy={filterBy}
            ref={ref}
            id={uuidv4}
            newSelectionPrefix="Přidat: "
            paginationText="Zobrazit více"
            labelKey="label"
            {...props}
             />
        )}
        </>
    );
}